module.exports = __webpack_public_path__ + "static/kate-walker-81370924123edaefdc47681cc9b87531.webp";